"use client";

// npm packages
import Image from "next/image";
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

// components
import Text from "../Text";
import Container from "../Container";
import Icon from "../Icon";
import { useStickySectionScroll } from "@/app/hooks/useStickySectionScroll";

// utils
import { cn } from "@/utils/cn";

const NavigationCategoryOne = ({
  breadcrumbData,
  categoryName,
  showTitle = true,
  className = "",
}) => {
  const router = useRouter();

  // scroll on for plp page
  const isSectionSticky = useStickySectionScroll();

  const [brandName, setBrandName] = useState("");

  // useEffect(() => {
  //   setBrandName(data);
  // }, [data]);

  return (
    <>
      <div
        className={cn(
          "bg-richcarmine transition-all duration-300 ease-in-out",
          {
            "!bg-cyan-cornflower-blue": categoryName === "beko",
            "sticky top-[64px] lg:top-[136px] z-[199]": isSectionSticky,
          },
          className
        )}
      >
        {/* px-15 sm:px-[30px] md:px-[60px] xl:px-[100px] 2xl:px-[100px] 3xl:px-0 */}
        <Container className="">
          <div className="relative flex flex-1 justify-center flex-col h-[40px] lg:h-[52px] py-10 overflow-hidden">
            {/* breadcrumb */}
            {/*   <div className="hidden lg:block absolute top-[15px] left-0">
              <ul className="w-full flex items-center">
                {breadcrumbData?.map((item, index) => {
                  const lastItem = index - (breadcrumbData.length - 1);

                  return (
                    <React.Fragment key={index}>
                      <li>
                        <Text
                          type="paragraph"
                          className={classNames("text-center text-14 text-heart-of-ice font-encode-sans font-medium leading-20 tracking-[0.28px]",
                            { "!font-bold": lastItem }
                          )}
                        >
                          <Link href="/">{item}</Link>
                        </Text>
                      </li>
                      {lastItem ?
                        <Icon
                          type="angle-right"
                          color="#DAE3F2"
                          className="size-[24px]"
                        />
                        : null}
                    </React.Fragment>
                  )
                })}
              </ul>
            </div> */}
            {/* title bar */}
            <div className="lg:hidden absolute top-auto bottom-auto left-0">
              <Icon
                type="angle-down"
                color="#fff"
                className="rotate-90 cursor-pointer"
                onClick={() => router.back()}
              />
            </div>
            <div className="flex justify-center items-center">
              {categoryName === "beko" ? (
                <Icon
                  type="beko"
                  color="#fff"
                  className="w-[67px] lg:w-[70px] h-[38px] lg:h-[40px]"
                />
              ) : showTitle ? (
                <div className="flex items-center gap-[10px] lg:gap-[8px]">
                  <div className="bg-white rounded-[6px]">
                    <Image
                      src="/icons/kitchen.svg"
                      width={32}
                      height={32}
                      alt="img"
                      className="size-[24px] lg:size-[32px]"
                    />
                  </div>
                  <Text
                    type="sub_title"
                    className="w-full text-center md:text-center !text-14 lg:!text-20 text-white font-medium leading-20 lg:leading-28 tracking-[0.28px] lg:tracking-[0.40px]"
                  >
                    {brandName ? brandName : categoryName}
                  </Text>
                </div>
              ) : null}
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default NavigationCategoryOne;
